import React, { useEffect } from "react";
import cx from "classnames";
import styles from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductConfigurationResultMainView.module.scss";
import { ProductConfiguratorResultSection } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductConfiguratoResultSection";
import { Select } from "components/Select/Select";
import { useTranslate } from "hooks";
import { ProductSuggestionTargetProperties } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ProductSuggestionTargetProperties";
import { ProductSuggestionResultTable } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ResultingListTable/ProductSuggestionResultTable";
import { ProductSuggestionAddons } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ResultingListForm/Addons/ProductSuggestionAddons";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { extractInitialValues } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ResultingListForm/ResultingListTableHelpers";
import { useResultingListForm } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/providers/ResultingListFormContextProvider";

type StrategyOption = {
  value: string;
  label: string;
};

type ProductSuggestionResultViewProps = {
  strategyOptions?: StrategyOption[];
  selectedOption?: StrategyOption;
  handleSelectStrategy: (option: StrategyOption) => void;
};

export const ProductSuggestionResultView = ({
  strategyOptions,
  handleSelectStrategy,
  selectedOption,
}: ProductSuggestionResultViewProps) => {
  const translate = useTranslate();
  const { product } = useProductConfiguratorStore.use.productData() || {};

  const { setInitValues } = useResultingListForm();

  useEffect(() => {
    if (
      !product?.listViewConfiguration?.attachments?.length &&
      !product?.listViewConfiguration?.accessories?.length
    )
      return;

    const initialValues = extractInitialValues([
      ...(product?.listViewConfiguration?.attachments ?? []),
      ...(product?.listViewConfiguration?.accessories ?? []),
    ]);

    setInitValues(initialValues);
  }, [
    product?.listViewConfiguration?.attachments,
    product?.listViewConfiguration?.accessories,
    setInitValues,
  ]);

  return (
    <div className={cx(styles.contentCard, "d-flex flex-column h-100 mt-3")}>
      <ProductConfiguratorResultSection
        title={translate("PRODUCT_SUGGESTION_INPUT")}
        classNames={cx(
          styles.acousticCell,
          "border rounded p-2 m-2 m-xxl-3 mt-xxl-0 p-xxl-2",
        )}
      >
        <div className="px-3">
          <h5 className="mb-2 font16 px-2">
            {translate("PRODUCT_SUGGESTION_STRATEGY")}
          </h5>
          <Select
            name={"strategy-select"}
            data-recording-disable={true}
            options={strategyOptions}
            onChange={handleSelectStrategy}
            isDisabled={false}
            value={selectedOption}
            className="font-md px-2"
          />
          <ProductSuggestionTargetProperties />
        </div>
      </ProductConfiguratorResultSection>
      {Boolean(
        product?.listViewConfiguration?.attachments?.length ||
        product?.listViewConfiguration?.accessories?.length,
      ) && (
        <ProductConfiguratorResultSection
          title={translate("PRODUCT_ADD_ON")}
          classNames={cx(
            styles.acousticCell,
            "border rounded p-2 m-2 m-xxl-3 mt-xxl-0 p-xxl-2",
          )}
        >
          <div className="px-3">
            <ProductSuggestionAddons />
          </div>
        </ProductConfiguratorResultSection>
      )}
      <ProductSuggestionResultTable />
    </div>
  );
};
